import getSupportCommercial from '@/services/catalogue/getSupportCommercial';
import { CATEGORIE_PRESSE } from '@/configuration/catalogue/produitConf';
import entiteCommercialeGenerer from '@/services/entiteCommerciale/genererEntiteCommerciale';
import { SENS_VENTE } from '@/configuration/devisConf';

export default async function genererProduitPresse() {
  const supportCommerical = await getSupportCommercial(CATEGORIE_PRESSE);
  return {
    reference: null,
    libelle: null,
    liaisonsTarif: [],
    reglesAchat: [],
    controleDisponibilite: true,
    supportCommercialId: supportCommerical.id,
    supportCommercial: supportCommerical,
    entiteCommerciale: entiteCommercialeGenerer(),
    schemaComptableId: null,
    schemaComptable: null,
    objectifsVente: [],
    produitPresse: {
      dateSignature: null,
      dateDebut: null,
      dateFin: null,
      produitParDefautId: null,
      encarts: [],
      nbTirage: null,
      margeHaut: null,
      margeGauche: null,
      largeurFormatUtile: null,
      hauteurFormatUtile: null,
      hauteurPleinPapier: null,
      largeurPleinPapier: null,
      modeDistributionId: null,
      typeFormatPresseId: null,
      prestationGracieuse: null,
    },
    agenceId: null,
    societeId: null,
    sens: SENS_VENTE,
    commissionsVendeur: [],
    cgvs: [],
    demandeInterventionTypes: [],
    compteAnalytiqueId: null,
    regleFacturationId: null,
    marcheId: null,
    assistantId: null,
    renouvelable: true,
  };
}
